import { TriggerButton } from './TriggerButton';

// TODO: in v9, move styled() from TriggerButton.jsx to here
export var StyledTriggerButton = TriggerButton;